(function () {
  const targetClass = 'bold-options-main-price';
  const priceSelectors = [
    '.product-info__price .price__default > .price__current',
    '.card--sticky-atc .price__default > .price__current'
  ];

  let scheduled = false;
  let attempts = 0;

  function hasBoldOptionsSurface() {
    return document.querySelector('.bold_options') || (window.BOLD && window.BOLD.options);
  }

  function markProductPrices() {
    document.querySelectorAll(priceSelectors.join(',')).forEach((priceEl) => {
      priceEl.classList.add(targetClass);
    });
  }

  function scopeBoldPriceUpdates() {
    const boldOptions = window.BOLD && window.BOLD.options;
    if (!boldOptions) return false;

    let configured = false;
    [boldOptions.settings, boldOptions.app && boldOptions.app.settings].forEach((settings) => {
      if (!settings || !settings.frontend) return;
      settings.frontend.option_price_display_class = targetClass;
      configured = true;
    });

    return configured;
  }

  function applyScope() {
    scheduled = false;
    attempts += 1;

    if (!hasBoldOptionsSurface()) {
      if (attempts < 120) {
        window.setTimeout(scheduleApply, 100);
      }
      return;
    }

    markProductPrices();
    const configured = scopeBoldPriceUpdates();

    if (attempts < 120 && (!configured || document.querySelector('.bold_options:not(.bold_options_loaded)'))) {
      window.setTimeout(scheduleApply, 100);
    }
  }

  function scheduleApply() {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(applyScope);
  }

  scheduleApply();
  document.addEventListener('DOMContentLoaded', scheduleApply);
  document.addEventListener('shopify:section:load', scheduleApply);
  document.addEventListener('on:variant:change', scheduleApply);

  const observer = new MutationObserver(scheduleApply);
  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
